import type { NavigateFunction, Location as RemixLocation } from '@remix-run/react';
import { applicationManager } from '~/lib/stores/applicationManager';
import { withResolvers } from '~/utils/promises';

const REDIRECT_FLAG = '_bolt_figma_';
const RETRY_FLAG = '_bolt_figma_try_again_';

export interface FigmaFrame {
  url: string;
  fileKey: string;
  nodeId: string;
}

const { setup: setupFigmaRedirect, has: isFigmaRedirect, reset: resetFigmaRedirect } = flags(REDIRECT_FLAG);

const { setup: setupFigmaRetry, has: isFigmaRetry, reset: resetFigmaRetry } = flags(RETRY_FLAG);

export { setupFigmaRedirect, isFigmaRedirect, resetFigmaRedirect, setupFigmaRetry, isFigmaRetry, resetFigmaRetry };

export function figmaURLFromRoute(location: RemixLocation) {
  const figmaURL = new URL('https://www.figma.com');

  figmaURL.pathname = location.pathname.replace(/^\/~\/figma.com/, '');
  figmaURL.search = location.search;

  return figmaURL;
}

export function figmaProjectName(url: string) {
  const parsed = new URL(url);

  const name = parsed.pathname.split('/').at(-1);

  return name ? decodeURIComponent(name) : undefined;
}

export async function ensureConnectionToFigma() {
  if (!applicationManager.hasConfiguration()) {
    await applicationManager.loadApplicationsConfiguration();
  }

  return applicationManager.applications.get().FIGMA === 'CONNECTED';
}

export async function connectToFigma() {
  const deferred = withResolvers<boolean>();

  const stop = applicationManager.applications.subscribe((apps) => {
    const figma = apps.FIGMA;

    if (figma === 'CONNECTED' || figma === 'DISCONNECTED') {
      queueMicrotask(() => stop());
      deferred.resolve(figma === 'CONNECTED');
    }
  });

  applicationManager.connect('FIGMA');

  return deferred.promise;
}

function flags(name: string) {
  return {
    setup() {
      sessionStorage.setItem(name, 'true');
    },
    has() {
      return sessionStorage.getItem(name) != null;
    },
    reset() {
      sessionStorage.removeItem(name);
    },
  };
}

export function redirectToFigmaImport(navigate: NavigateFunction, frame: FigmaFrame, reload = false) {
  setupFigmaRedirect();

  if (reload) {
    window.location.href = `/~/${frame.url.replace(/^https?:\/\/(www\.)?/, '')}`;
  } else {
    navigate(`/~/${frame.url.replace(/^https?:\/\/(www\.)?/, '')}`);
  }
}
